import { Table, Input, Spin, Tooltip as tooltip, Popover } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import { Button, Modal } from "antd";
import React, { useState, useEffect, useRef } from "react";
import { Checkbox, DatePicker } from "antd";
import Highlighter from "react-highlight-words";
import {
  SearchOutlined,
  SwapOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { get } from "../Libraries/Ajax/HttpService";
import Outliersnew from "./Outliersnew";
import Outlierovertime from "./Outlierovertime";
import { Space, Slider } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {
  XAxis,
  YAxis,
  Legend,
  CartesianGrid,
  Line,
  Tooltip,
  LineChart,
  ResponsiveContainer,
} from "recharts";
import back from "../assets/images/back.svg";
import qs from "qs";
import { useDistrict } from "../utils/DistrictContext";
function Outliers() {
  var mcdata = JSON.parse(localStorage.getItem("MCData"));
  // let history = useHistory();
  const navigate = useNavigate();
  const [datas, setdatas] = useState([]);
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(true);
  const [open, setOpen] = useState(false);
  const [first, setFirst] = useState(false);
  const [second, setSecond] = useState(true);
  const [third, setThird] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selected, setSelected] = useState("week");
  const [parameterone, setParameterone] = useState();
  const [parametertwo, setParametertwo] = useState();
  const [defaultOption, setDefaultOption] = useState("Past Week");
  const [matching, setMatching] = useState(0);
  const [outliers, setOutliers] = useState(0);
  const [point, setPoint] = useState(0);
  const [slvalue, setSlvalue] = useState(10);
  const [outlierdata, setOutlierdata] = useState(null);
  const { RangePicker } = DatePicker;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const { selectedDistrict } = useDistrict();
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const columnss = [
    {
      title: "Meter",
      dataIndex: "Meter",
      key: "Meter",
      children: [
        {
          title: "Account",
          dataIndex: "overided_name",
          key: "overided_name",
          width: "10%",

          sorter: true,
        },

        {
          title: "Meter ID",
          dataIndex: "meter_id",
          key: "meter_id",
          width: "5%",
          sorter: true,
        },
        {
          title: "Register",
          dataIndex: "register_number",
          key: "register_number",
          width: "5%",
          sorter: true,
        },

        {
          title: "Category",
          dataIndex: "service_name",
          key: "service_name",
          width: "7%",
          sorter: true,
        },
        {
          title: "Mean",
          dataIndex: "mean_meter",
          key: "mean_meter",
          width: "4%",
          sorter: true,
        },
        {
          title: "Standard Deviation",
          dataIndex: "stddev_meter",
          key: "stddev_meter",
          width: "8%",
          sorter: true,
        },
      ],
    },
    {
      title: "Outlier",
      dataIndex: "Outlier",
      key: "Outlier",
      children: [
        {
          title: "Time",
          dataIndex: "flow_time",
          key: "flow_time",
          width: "8%",
          sorter: true,
        },

        {
          title: "Value ",
          dataIndex: "flow",
          key: "flow",
          width: "6%",
          sorter: true,
        },
        {
          title: "Standard Score",
          dataIndex: "standard_score",
          key: "standard_score",
          width: "8%",
          sorter: true,
        },

        {
          title: "Standard Score(Absolute)",
          dataIndex: "absolute_standard_score",
          key: "absolute_standard_score",
          width: "10%",
          sorter: true,
        },

        // {
        //     title: 'Manually Excluded',
        //     dataIndex: 'manually_excluded',
        //     key: 'manually_excluded',
        //     width: '10%',
        //     render: (_, record) => (

        //         <Checkbox checked={record.manually_excluded} disabled={true} />

        //     )

        // },
      ],
    },
  ];

  const columns = [
    {
      title: "Meter",
      dataIndex: "Meter",
      key: "Meter",
      children: [
        {
          title: "ID",
          dataIndex: "meter_id",
          key: "meter_id",
          width: "5%",
          //  ...getColumnSearchProps('account'),
          // sorter: (a, b) => a.meter_id.localeCompare(b.meter_id),
          sorter: (a, b) => a.meter_id - b.meter_id,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Register",
          dataIndex: "register_number",
          key: "register_number",
          width: "5%",
          //  ...getColumnSearchProps('meter_id'),
          sorter: (a, b) => a.register_number.localeCompare(b.register_number),
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Account",
          dataIndex: "overided_name",
          key: "overided_name",
          width: "5%",
          //  ...getColumnSearchProps('overided_name'),

          sorter: (a, b) => a.overided_name.localeCompare(b.overided_name),
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Category",
          dataIndex: "service_name",
          key: "service_name",
          width: "5%",
          //  ...getColumnSearchProps('service_name'),
          sorter: (a, b) => a.service_name.localeCompare(b.service_name),
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Mean",
          dataIndex: "mean_meter",
          key: "mean_meter",
          width: "4%",
          //  ...getColumnSearchProps('meter_type'),
          sorter: (a, b) => a.mean_meter - b.mean_meter,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Standard Deviation",
          dataIndex: "stddev_meter",
          key: "stddev_meter",
          width: "8%",
          //  ...getColumnSearchProps('stddev_meter'),
          sorter: (a, b) => a.stddev_meter - b.stddev_meter,
          // sortDirections: ['descend', 'ascend'],
        },
        {
          title: "Value Range",
          dataIndex: "min_flow",
          key: "min_flow",
          width: "6%",
          // ...getColumnSearchProps('meter_size'),
          // sorter: (a, b) => a.min_flow - b.min_flow,
          // sortDirections: ['descend', 'ascend'],
        },
        // {
        //     title: 'Graph',
        //     dataIndex: 'dials',
        //     key: 'dials',
        //     width: '4%',
        //     // ...getColumnSearchProps('dials'),
        //     sorter: (a, b) => a.dials - b.dials,
        //     sortDirections: ['descend', 'ascend'],
        // },
      ],
    },
    {
      title: "Included Outliers",
      dataIndex: "Included Outliers",
      key: "Included Outliers",
      children: [
        {
          title: "Count",
          dataIndex: "include_count",
          key: "include_count",
          width: "4%",
          // ...getColumnSearchProps('register_resolution'),
          sorter: (a, b) => a.include_count - b.include_count,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Absolute Standard Score Range",
          dataIndex: "include_min",
          key: "include_min",
          width: "12%",
          //  ...getColumnSearchProps('include_min'),
          // sorter: (a, b) => a.include_min - b.include_min,
          // sortDirections: ['descend', 'ascend'],
        },
        {
          title: "Value Range",
          dataIndex: "include_flow_min",
          key: "include_flow_min",
          width: "6%",
          // ...getColumnSearchProps('meter_size'),
          // sorter: (a, b) => a.min_flow - b.min_flow,
          // sortDirections: ['descend', 'ascend'],
        },
      ],
    },
    {
      title: "Excluded Outliers",
      dataIndex: "Excluded Outliers",
      key: "Excluded Outliers",
      children: [
        {
          title: "Count",
          dataIndex: "exclude_count",
          key: "exclude_count",
          width: "4%",
          // ...getColumnSearchProps('register_resolution'),
          sorter: (a, b) => a.exclude_count - b.exclude_count,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Absolute Standard Score Range",
          dataIndex: "exclude_min",
          key: "exclude_min",
          width: "12%",
          //  ...getColumnSearchProps('include_min'),
          // sorter: (a, b) => a.exclude_min - b.exclude_min,
          // sortDirections: ['descend', 'ascend'],
        },
        {
          title: "Value Range",
          dataIndex: "exclude_flow_min",
          key: "exclude_flow_min",
          width: "6%",
          // ...getColumnSearchProps('meter_size'),
          // sorter: (a, b) => a.exclude_flow_min - b.exclude_flow_min,
          // sortDirections: ['descend', 'ascend'],
        },
      ],
    },
  ];

  const onchange = (value, dateString) => {
    // console.log(value[0]._d);

    setParameterone(dateString[0]);
    setParametertwo(dateString[1]);

    console.log("1", dateString[0]);
    console.log(parameterone);
    console.log("2", dateString[1]);
    console.log(parametertwo);
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };
  const onMouseClick = (event) => {
    setDefaultOption(event.target.value);
    setOutlierdata(null);
    setMatching(null);
    setOutliers(null);

    setPoint(null);
    console.log(selected);
  };
  const handleOk = () => {
    // setToggle(false);
  };
  const sliderChange = (event) => {
    // setToggle(false);
    setSlvalue(event);
    setOutlierdata(null);
    setMatching(null);
    setOutliers(null);

    setPoint(null);
  };

  const modalclick = () => {
    setOpen(true);
  };

  const onselectClick = () => {
    // history.push('/outlierovertime');
    setSecond(false);
    setFirst(false);
    setThird(true);
  };
  const onselectClickss = () => {
    // history.push('/outliersnew');
    // <Outliersnew/>

    setSecond(true);
    setFirst(false);
    setThird(false);
  };

  const handleNotificationpageclick = () => {
    navigate("/notificationss");
  };
  const onselectClicks = () => {
    // history.push('/outliers');

    setFirst(true);
    setSecond(false);
    setThird(false);
  };
  const onRedirection = (event) => {
    // history.push('/dashboard');
    // window.history.back();
    navigate(-1);
  };
  const [datass, setDatass] = useState();
  // const [loading, setLoading] = useState(false);
  const [field, setField] = useState();
  const [order, setOrder] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const getRandomuserParams = (params) => ({
    page_limit: params.pagination?.pageSize,
    page: params.pagination?.current,
    sort_field: field,
    sort_type: order,
    ...params,
  });
  const fetchData = () => {
    // setData(null);
    setloading(true);
    if (
      defaultOption == "Custom" &&
      parameterone != undefined &&
      parametertwo != undefined
    ) {
      get(
        `apis/outliers/new?option=${defaultOption}&minimum_score=${slvalue}&start_date=${parameterone}&end_date=${parametertwo}&${qs.stringify(getRandomuserParams(tableParams))}`,
      ).then((res) => {
        setTimeout(() => {
          console.log(res.data.outliers_by_meter);
          setDatass(res?.data?.outliers_by_meter);

          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: res.data.outliers_count,
            },
          });
          setloading(false);
        }, 1000);
      });
    } else {
      get(
        `apis/outliers/new?option=${defaultOption}&minimum_score=${slvalue}&${qs.stringify(getRandomuserParams(tableParams))}`,
      ).then((res) => {
        setTimeout(() => {
          console.log(res.data.outliers_by_meter);
          setDatass(res?.data?.outliers_by_meter);

          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: res.data.outliers_count,
            },
          });
          setloading(false);
        }, 1000);
      });
    }
    // setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [
    parameterone,
    parametertwo,
    defaultOption,
    slvalue,
    JSON.stringify(tableParams.pagination.current),
    JSON.stringify(tableParams.pagination.pageSize),
    JSON.stringify(tableParams.column),
    JSON.stringify(tableParams.order),
    selectedDistrict,
  ]);
  const handleTableChange = (pagination, filters, sorter) => {
    console.log(sorter);
    setField(sorter.field);
    setOrder(sorter.order);
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
    console.log(tableParams);
    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setDatass([]);
    }
  };
  useEffect(() => {
    getData();
  }, [parameterone, parametertwo, defaultOption, slvalue, selectedDistrict]);

  const getData = async () => {
    if (
      defaultOption == "Custom" &&
      parameterone != undefined &&
      parametertwo != undefined
    ) {
      setloading(true);
      get(
        `apis/outliers_count/new?option=${defaultOption}&start_date=${parameterone}&end_date=${parametertwo}&minimum_score=${slvalue}`,
      ).then((response) => {
        setTimeout(() => {
          console.log(response.data);

          setOutlierdata(response.data);
          setMatching(response.data.data.outliers_count);
          setOutliers(response.data.data.outliers);
          let a = response.data.data.point_count;
          setPoint((a || 0).toLocaleString());
        }, 1000);
      });

      get(
        `apis/outliers_by_meter/new?option=${defaultOption}&start_date=${parameterone}&end_date=${parametertwo}&minimum_score=${slvalue}`,
      ).then((res) => {
        setTimeout(() => {
          setdata(
            res.data.outliers_by_meter.map((row) => ({
              exclude_flow_min:
                row.exclude_flow_min && row.exclude_flow_max
                  ? row.exclude_flow_min + "-" + row.exclude_flow_max
                  : row.exclude_flow_min
                    ? row.exclude_flow_min
                    : row.exclude_flow_max
                      ? row.exclude_flow_max
                      : "",
              meter_id: row.meter_id,
              include_flow_min:
                row.include_flow_min && row.include_flow_max
                  ? row.include_flow_min + "-" + row.include_flow_max
                  : row.include_flow_min
                    ? row.include_flow_min
                    : row.include_flow_max
                      ? row.include_flow_max
                      : "",
              register_number: row.register_number,
              include_count: row.include_count,
              exclude_min:
                row.exclude_min && row.exclude_max
                  ? row.exclude_min + "-" + row.exclude_max
                  : row.exclude_min
                    ? row.exclude_min
                    : row.exclude_max
                      ? row.exclude_max
                      : "",
              overided_name: row.overided_name,
              service_name: row.service_name,
              mean_meter: row.mean_meter,
              stddev_meter: row.stddev_meter,
              min_flow:
                row.min_flow && row.max_flow
                  ? row.min_flow + "-" + row.max_flow
                  : row.min_flow
                    ? row.min_flow
                    : row.max_flow
                      ? row.max_flow
                      : "",
              exclude_count: row.exclude_count,
              // include_count: row.include_count,
              include_min:
                row.include_min && row.include_max
                  ? row.include_min + "-" + row.include_max
                  : row.include_min
                    ? row.include_min
                    : row.include_max
                      ? row.include_max
                      : "",
            })),
          );
          setdatas(res.data.outliers_by_meter);
          console.log(res.data.outliers_by_meter);
          setloading(false);
        }, 1000);
      });
    } else {
      setloading(true);
      get(
        `apis/outliers_count/new?option=${defaultOption}&minimum_score=${slvalue}`,
      ).then((response) => {
        setTimeout(() => {
          console.log(response.data);

          setOutlierdata(response.data);
          console.log("check", response.data);
          setMatching(response.data.data.outliers_count);
          setOutliers(response.data.data.outliers);
          setPoint((response.data.data.point_count || 0).toLocaleString());
        }, 1000);
      });

      get(
        `apis/outliers_by_meter/new?option=${defaultOption}&minimum_score=${slvalue}`,
      ).then((res) => {
        setTimeout(() => {
          setdata(
            res.data.outliers_by_meter.map((row) => ({
              exclude_flow_min:
                row.exclude_flow_min == row.exclude_flow_max
                  ? row.exclude_flow_min
                  : (row.exclude_flow_min >= 0 || row.exclude_flow_min <= 0) &&
                      (row.exclude_flow_max >= 0 ||
                        row.exclude_flow_max <= 0) &&
                      row.exclude_flow_min != row.exclude_flow_max
                    ? row.exclude_flow_min + "-" + row.exclude_flow_max
                    : row.exclude_flow_min
                      ? row.exclude_flow_min
                      : row.exclude_flow_max
                        ? row.exclude_flow_max
                        : "",
              meter_id: row.meter_id,
              include_flow_min:
                row.include_flow_max == row.include_flow_min
                  ? row.include_flow_min
                  : (row.include_flow_max >= 0 || row.include_flow_max <= 0) &&
                      (row.include_flow_min >= 0 ||
                        row.include_flow_min <= 0) &&
                      row.include_flow_max != row.include_flow_min
                    ? row.include_flow_min + "-" + row.include_flow_max
                    : row.include_flow_min
                      ? row.include_flow_min
                      : row.include_flow_max
                        ? row.include_flow_max
                        : "",
              register_number: row.register_number,
              // include_count: row.include_count,
              exclude_min:
                row.exclude_min == row.exclude_max
                  ? row.exclude_min
                  : (row.exclude_max >= 0 || row.exclude_max <= 0) &&
                      (row.exclude_min >= 0 || row.exclude_min <= 0) &&
                      row.exclude_min != row.exclude_max
                    ? row.exclude_min + "-" + row.exclude_max
                    : row.exclude_min
                      ? row.exclude_min
                      : row.exclude_max
                        ? row.exclude_max
                        : "",
              overided_name: row.overided_name,
              service_name: row.service_name,
              mean_meter: row.mean_meter,
              stddev_meter: row.stddev_meter,
              min_flow:
                row.min_flow == row.max_flow
                  ? row.min_flow
                  : (row.min_flow >= 0 || row.min_flow <= 0) &&
                      (row.max_flow >= 0 || row.max_flow <= 0) &&
                      row.min_flow != row.max_flow
                    ? row.min_flow + "-" + row.max_flow
                    : row.min_flow
                      ? row.min_flow
                      : row.max_flow
                        ? row.max_flow
                        : "",
              exclude_count: row.exclude_count,
              include_count: row.include_count,
              //include_min: ((row.include_min == row.include_max) ? row.include_min:(row.include_min && row.include_max && row.include_min !=row.include_max)? (row.include_min + "-" + row.include_max) :(row.include_min ? row.include_min : (row.include_max ? row.include_max : "")))
              include_min:
                row.include_max == row.include_min
                  ? row.include_min
                  : (row.include_max >= 0 || row.include_max <= 0) &&
                      (row.include_min >= 0 || row.include_min <= 0) &&
                      row.include_max != row.include_min
                    ? row.include_min + "-" + row.include_max
                    : row.include_min
                      ? row.include_min
                      : row.include_max
                        ? row.include_max
                        : "",
            })),
          );
          setdatas(res.data.outliers_by_meter);
          console.log(res.data.outliers_by_meter);
          setloading(false);
        }, 1000);
      });
    }
  };

  const handleNotificationclick = () => {
    navigate("/alert#/action-2");
  };

  const [myData, setmyData] = useState([]);
  // const arryDatas = [];
  // useEffect(() => {
  //     const isMizuWatch = window.location.href.includes("mizuwatch.com");
  //     document.title = isMizuWatch ? "MizuWatch" : "MizuSmart";
  //   }, []);
  useEffect(() => {
    console.log(data.data);
    getDatas();
  }, [parameterone, parametertwo, defaultOption, slvalue, selectedDistrict]);

  const getDatas = async () => {
    // const arryDatas = [];
    if (
      defaultOption == "Custom" &&
      parameterone != undefined &&
      parametertwo != undefined
    ) {
      setloading(true);

      get(
        `apis/outliers_time/new?start_date=${parameterone}&end_date=${parametertwo}&minimum_score=${slvalue}&option=${defaultOption}`,
      ).then((res) => {
        console.log("Outlierovertime", res.data.outliers_by_meter);
        // res.data.outliers_by_meter.forEach((x) => {
        //     let Obj = {
        //         name: x.flow_time_date,
        //         names: x.flow_time_month,
        //         Excluded: x.exclude_count,
        //         Included: x.include_count,

        //     };
        //     arryDatas.push(Obj);
        // });
        // setmyData(arryDatas);
        const arryDatas = res.data.outliers_by_meter.map((x) => ({
          name: x.flow_time_date,
          names: x.flow_time_month,
          Excluded: x.exclude_count,
          Included: x.include_count,
        }));

        setmyData(arryDatas);
        console.log(myData);
        setloading(false);
      });
    } else {
      setloading(true);

      get(
        `apis/outliers_time/new?&minimum_score=${slvalue}&option=${defaultOption}`,
      ).then((res) => {
        console.log("Outlierovertime", res.data.outliers_by_meter);
        // res.data.outliers_by_meter.forEach((x) => {
        //     let Obj = {
        //         name: x.flow_time_date,
        //         names: x.flow_time_month,
        //         Excluded: x.exclude_count,
        //         Included: x.include_count,

        //     };
        //     arryDatas.push(Obj);
        // });
        // setmyData(arryDatas);
        const arryDatas = res.data.outliers_by_meter.map((x) => ({
          name: x.flow_time_date,
          names: x.flow_time_month,
          Excluded: x.exclude_count,
          Included: x.include_count,
        }));

        setmyData(arryDatas);

        console.log(myData);
        setloading(false);
      });
    }
  };
  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex ">
              <img
                src={back}
                alt=""
                style={{ width: "10px", cursor: "pointer" }}
                onClick={onRedirection}
              />
              {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
              {/* <h3 className="mb-0">Data Outliers</h3> */}
              <div className="d-flex align-items-center">
                <div
                  className="new-box-padding   align-self-center c-pointer "
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                  onClick={handleNotificationclick}
                >
                  Notification
                </div>
                {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                  ""
                ) : (
                  <>
                    {" "}
                    <div
                      className=""
                      style={{
                        width: "2px",
                        height: "25px",
                        background: "#ccc",
                      }}
                    ></div>
                    <div
                      className="new-box-padding   align-self-center c-pointer  "
                      onClick={handleNotificationpageclick}
                      style={{
                        borderBottom: "2px solid #ccc",
                      }}
                    >
                      Reports and Alerts
                    </div>{" "}
                  </>
                )}
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding  text-blue  align-self-center c-pointer"
                  style={{
                    borderBottom: "2px solid #1998f0",
                    borderRadius: "0",
                  }}
                >
                  Data Outliers
                </div>
              </div>
            </div>
            {/* <div className="d-flex align-items-center">
                      
                        <div className="new-box-padding text-blue  bg-white border border-info rounded align-self-center c-pointer me-2"
                            >
                               Data Outliers
                            </div> 
                        <div className="new-box-padding bg-white border rounded align-self-center c-pointer me-2"
                                 onClick={handleNotificationpageclick}
                            >
                               Notification Settings 
                            </div> 
                           
                        
                        </div> */}
            <div
              className="d-flex selectCalender outliers-section"
              style={{ boxShadow: "none", padding: "0" }}
            >
              <div
                className="fs-26 fw-bold d-flex outliers-select"
                style={{ minWidth: "145px", padding: "5px 0px" }}
              >
                <select
                  name="All meters"
                  id="selector"
                  className="box border-0 w-100"
                  onChange={onMouseClick}
                  style={{ padding: "0px 16px" }}
                >
                  <option value="Past Year">Past Year</option>
                  <option value="Past 3 Months">Past 3 Months </option>
                  <option value="Past Month">Past Month</option>
                  <option value="Past Week" selected>
                    Past Week
                  </option>
                  <option value="Past day">Past Day</option>
                  <option value="Custom">Custom</option>
                </select>
              </div>
              <Space direction="horizontal" size={1} className="">
                {defaultOption === "Custom" ? (
                  <RangePicker
                    onChange={onchange}
                    separator={<SwapOutlined />}
                  />
                ) : (
                  ""
                )}
              </Space>
            </div>
          </div>
        </div>
        <div className="fs-20 fw-bold d-flex gap-3 d-flex align-items-center justify-content-between flex-wrap mt-4">
          <div className="d-flex gap-3 flex-wrap">
            {second === true ? (
              <div
                className="px-3 py-1 text-blue bg-white border border-info rounded align-self-center c-pointer"
                onClick={onselectClickss}
              >
                Outliers
              </div>
            ) : (
              <div
                className="px-3 py-1 bg-white border rounded align-self-center c-pointer"
                onClick={onselectClickss}
              >
                Outliers
              </div>
            )}
            {first === true ? (
              <div
                className="px-3 py-1 text-blue bg-white border border-info rounded align-self-center c-pointer"
                onClick={onselectClicks}
              >
                Outliers By Meter
              </div>
            ) : (
              <div
                className="px-3 py-1 bg-white border rounded align-self-center c-pointer"
                onClick={onselectClicks}
              >
                Outliers By Meter
              </div>
            )}
            {third === true ? (
              <div
                className="px-3 py-1 text-blue bg-white border border-info rounded align-self-center c-pointer"
                onClick={onselectClick}
              >
                Outliers Over Time
              </div>
            ) : (
              <div
                className="px-3 py-1 bg-white border rounded align-self-center c-pointer"
                onClick={onselectClick}
              >
                {" "}
                Outliers Over Time
              </div>
            )}
          </div>
          <div className="fw-bold d-flex gap-1000 ">
            <div className="float-right">
              <h6 className="fs-14">
                Filter By Minimum Absolute Standard Score
              </h6>
              <div className="row align-items-center">
                <div className="col-lg-9">
                  <Slider
                    min={5}
                    max={100}
                    onAfterChange={sliderChange}
                    defaultValue={10}
                  />
                </div>
                <div className="col-lg-3">
                  <Input
                    type="text"
                    min={5}
                    max={20}
                    value={slvalue}
                    readOnly={true}
                    onChange={sliderChange}
                    style={{ border: "1px solid #d9d9d9" }}
                  />
                </div>
              </div>

              {/* <Row>
      <Col span={12}>
         <Slider defaultValue={10} disabled={false} min={1} max={100} onAfterChange={sliderChange}  />
      </Col>
      <Col span={4}>
        <InputNumber
          min={1}
          max={20}
          style={{
            margin: '0 16px',
          }}
          value={slvalue}
          onChange={sliderChange}
        />
      </Col>
    </Row> */}
            </div>
          </div>
        </div>

        {/* <Slider defaultValue={30} onChange={onChange}  /> */}
        <div className="row row-cols-4 mt-4 g-3">
          <div className="col-12 col-lg">
            <div className="trend text-center">
              <p className="text-grey">
                <Space size={4}>
                  Matching Outliers
                  <Popover
                    trigger="click"
                    content={
                      <div style={{ width: "250px", textAlign: "left" }}>
                        Total number of flows whose absolute standard score
                        value is greater than or equal to the Minimum Absolute
                        Standard Score value selected in the filter within the
                        chosen date range.
                      </div>
                    }
                    placement="top"
                    getPopupContainer={(trigger) => trigger.parentElement}
                  >
                    <InfoCircleOutlined
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        marginTop: "8px",
                      }}
                    />
                  </Popover>
                </Space>
              </p>
              {outlierdata ? (
                <span className="trend-span"> {matching}</span>
              ) : (
                <Spin />
              )}
            </div>
          </div>
          <div className="col-12 col-lg">
            <div className="trend">
              <p className="text-grey">
                <Space size={4}>
                  Points
                  <Popover
                    trigger="click"
                    content={
                      <div style={{ width: "250px", textAlign: "left" }}>
                        Total number of flows within the chosen date range.
                      </div>
                    }
                    placement="top"
                    getPopupContainer={(trigger) => trigger.parentElement}
                  >
                    <InfoCircleOutlined
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        marginTop: "8px",
                      }}
                    />
                  </Popover>
                </Space>
              </p>
              {outlierdata ? (
                <span className="trend-span"> {point}</span>
              ) : (
                <Spin />
              )}
            </div>
          </div>
          <div className="col-12 col-lg">
            <div className="trend">
              <p className="text-grey">
                <Space size={4}>
                  Outliers
                  <Popover
                    trigger="click"
                    content={
                      <div style={{ width: "250px", textAlign: "left" }}>
                        Calculated as: (matched outliers / points) * 100
                      </div>
                    }
                    placement="top"
                    getPopupContainer={(trigger) => trigger.parentElement}
                  >
                    <InfoCircleOutlined
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        color: "#1890ff",
                        cursor: "pointer",
                        marginTop: "8px",
                      }}
                    />
                  </Popover>
                </Space>
              </p>

              {outlierdata ? (
                <span className="trend-span">{outliers}% </span>
              ) : (
                <Spin />
              )}
            </div>
          </div>
          {/* <div className="col-12 col-lg">
                        <div className="trend">
                            <p className="text-grey">Inactive Metes</p>
                            <span className="text-red">0</span>
                        </div>
                    </div> */}
        </div>
        <br />

        {/* <div className='col-12 gap-3'> */}
        {/* <Tag className="rounded border-info text-blue mb-3 bg-white ms-auto d-table py-1 px-2">Meter</Tag> */}
        {/* <button className="rounded border-info text-blue mb-3 bg-white ms-auto d-table py-1 px-2" onClick={modalclick}>Add / Remove</button> </div> */}
        {first === true && loading === false ? (
          <div>
            {/* <div className='d-flex'>
                            <h6 className="  text-blue col mb-3 px-2">Meter</h6>
                            <h6 className="  text-blue col mb-3 text-right me-4 px-2">Included Outliers</h6>
                            <h6 className=" text-blue mb-3 text-right col me-4 px-2">Excluded Outliers</h6>
                        </div> */}
            <Table
              columns={columns}
              dataSource={data}
              className="styleRemove"
              pagination={false}
              loading={loading}
              columnWidth={15}
              scroll={{
                x: 2000,
                y: 500,
              }}
            />
          </div>
        ) : second === true && loading === false ? (
          <Table
            columns={columnss}
            className="styleRemove  over-view outliers-sty"
            columnWidth={10}
            scroll={{
              x: 2000,
              y: 500,
            }}
            //   rowKey={(record) => record.login.uuid}
            dataSource={datass}
            pagination={tableParams.pagination}
            loading={loading}
            onChange={handleTableChange}
          />
        ) : (
          <>
            {" "}
            <div className="bottom-layout">
              {loading === false ? (
                <div
                  style={{
                    maxWidth: "96%",
                    margin: "0 auto",
                    height: "500px",
                    position: "relative",
                  }}
                >
                  <ResponsiveContainer>
                    <LineChart
                      data={myData}
                      // margin={{ top: 25, right: 25, bottom: 25, left: 0 }}
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      {defaultOption === "Past Year" ||
                      Math.floor(
                        (new Date(parametertwo) - new Date(parameterone)) /
                          (1000 * 60 * 60 * 24) /
                          7,
                      ) > 12 ? (
                        <>
                          <XAxis
                            xAxisId="0"
                            dataKey="name"
                            tick={false}
                            textAnchor="end"
                          />
                          <XAxis
                            dataKey="names"
                            xAxisId="1"
                            textAnchor="end"
                            allowDuplicatedCategory={false}
                            //  angle={-45} textAnchor="end"
                          />
                        </>
                      ) : (
                        <XAxis
                          xAxisId="0"
                          dataKey="name"
                          textAnchor="end"
                          allowDuplicatedCategory={false}
                        />
                      )}
                      {/* <XAxis dataKey="name" />
                        <XAxis dataKey="names" /> */}
                      <YAxis />
                      <Legend />
                      <Line
                        type="monotone"
                        dataKey="Excluded"
                        isAnimationActive={false}
                        name="Excluded"
                        fill="#488ac7"
                        stroke="#93ffe8"
                      ></Line>
                      <Line
                        type="monotone"
                        dataKey="Included"
                        isAnimationActive={false}
                        name="Included"
                        fill="#43c6db"
                        stroke="#6699CC"
                      ></Line>
                      <CartesianGrid stroke="lightGrey" />
                      <Tooltip />
                    </LineChart>
                  </ResponsiveContainer>
                  <div className="labelYAxis3">Count</div>
                </div>
              ) : (
                <div className="example">
                  <Spin />
                </div>
              )}
            </div>
          </>
        )}
        {open === true ? (
          <Modal
            open={open}
            onOk={handleOk}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            centered="true"
            className="selectCheckbox"
          >
            <div className="row mt-4 fs-20 checkboxGreen">
              <div>
                <Checkbox>ID</Checkbox>
                <Checkbox>Register</Checkbox>
                <Checkbox>Account</Checkbox>
              </div>
              <div className="text-blue px-3 included-outliers">
                Included Outliers
              </div>
              <div>
                <Checkbox>Count</Checkbox>
                <Checkbox>Register</Checkbox>
                <Checkbox>Value Range</Checkbox>
              </div>
            </div>
          </Modal>
        ) : (
          ""
        )}
      </Main>
    </>
  );
}

export default Outliers;
